module.exports = __webpack_public_path__ + "img/GPUpisition.3bcd8cdb.png";